import { gql } from '@apollo/client';

const BlendedComputationDetails = gql`
  fragment BlendedComputationDetails on InvoiceMargins {
    blended
    blendedComputation {
      newGlp
      previousGlp
      upsellPercentage
      renewPercentage
      upsellValue
      renewalValue
      upsellMargin
      renewalMargin
      blendedMargin
    }
  }
`;

export const lineItemDetailsForInvoiceInPPC = gql`
  ${BlendedComputationDetails}
  fragment lineItemDetailsForInvoiceInPPC on InvoiceLineItems {
    id
    edition
    entitlementId
    entitlementNumber
    cloudSiteHostname
    amount
    subtotal
    description
    cloudSiteId
    platform
    productKey
    productName
    startDate
    invoiceLineItemId
    endDate
    originalInvoiceReferral {
      invoiceNumber
    }
    promotionItems {
      id
      title
      applicationReason {
        id
        readableName
        customisable {
          id {
            type
            anyOf {
              readableName
              id
            }
          }
        }
      }
      purpose {
        reasonCode
        name
        invoiceNote
      }
      benefits {
        duration
        benefitType
        subBenefitType
        value
        iterations
      }
      status
      eligibilityRules {
        currency
      }
    }
    discounts {
      amount
      type
      percent
      reason
      reasonCode
      promotionId
    }
    margins {
      type
      amount
      percent
      promotionId
      ...BlendedComputationDetails
    }
    entitlement {
      id
      entitlementNumber
      baseProduct
      cloudSiteId
      cloudSiteUrl
      accountId: orgId
      platform
      productId
      productName
      parentSen
      sourceSystem
      billingCycle
      billingStatus
      businessKey: id
      pricingPlanId
      offeringId
      isSandbox
      isAddOn
      scheduledChanges {
        chargeQuantities {
          chargeElement
          quantity
          lastUpdatedAt
          usersUpdate {
            isAdded
            isRemoved
            isCreated
            changeBy
          }
        }
      }
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
      relatesToEntitlements {
        entitlementId
        relationshipType
      }
    }
    essotEntitlement {
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
      relatesToEntitlements {
        entitlementId
        relationshipType
      }
    }
    promotionIds
    quantity
    sen
    pricingPlanId
    orgInfo {
      orgId
      orgName
    }
    pricingPlan {
      type
      billingFrequency
      id
      currency
      pricingPlanType
      status
      description
      tiers {
        unitAmount
        flatAmount
        floor
        ceiling
      }
    }
    taxRate
    taxAmountPaymentCurrency
    taxItems {
      id
      taxPercent
      tax
      taxId
      taxAmountLabel
      taxIdLabel
    }
    latestInvoiceDetails {
      id
      invoiceNumber
    }
    logoId
  }
`;

const productAppLineItemsInPPC = gql`
  ${lineItemDetailsForInvoiceInPPC}
  fragment productAppLineItemsInPPC on ProductAppLineItem {
    products {
      ...lineItemDetailsForInvoiceInPPC
    }
    apps {
      ...lineItemDetailsForInvoiceInPPC
    }
    addOns @include(if: $fetchAddOns) {
      ...lineItemDetailsForInvoiceInPPC
    }
  }
`;

export const coupledLineItemsOnInvoiceInPPC = gql`
  ${productAppLineItemsInPPC}
  fragment coupledLineItemsOnInvoiceInPPC on ProductAppLineItemData {
    jira {
      ...productAppLineItemsInPPC
    }
    confluence {
      ...productAppLineItemsInPPC
    }
    statuspage {
      ...productAppLineItemsInPPC
    }
    atlassianGuard @include(if: $fetchAGPAddon) {
      ...productAppLineItemsInPPC
    }
    other {
      ...productAppLineItemsInPPC
    }
  }
`;
